"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayWithBackground = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var colors_1 = require("../../styles/colors");

var color_1 = require("../../styles/utils/color");

exports.OverlayWithBackground = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: ", ";\n\tposition: ", ";\n\tbackground: ", ";\n\t", ";\n"], ["\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: ", ";\n\tposition: ", ";\n\tbackground: ", ";\n\t", ";\n"])), function (_a) {
  var $zIndex = _a.$zIndex;
  return $zIndex;
}, function (_a) {
  var $position = _a.$position;
  return $position;
}, function (_a) {
  var $transparent = _a.$transparent;
  return $transparent ? 'transparent' : color_1.getColorWithAlpha(colors_1.black, 0.8);
}, function (_a) {
  var onClick = _a.onClick,
      $cursor = _a.$cursor;
  return onClick && $cursor && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t\tcursor: pointer;\n\t\t"], ["\n\t\t\tcursor: pointer;\n\t\t"])));
});
var templateObject_1, templateObject_2;